import { gql, ApolloClient } from '@apollo/client'
import { PopularArticles, PopularArticlesVariables } from '@apollo-types/PopularArticles'

const POPULAR_ARTICLES = gql`
  query PopularArticles($categoryId: String!) {
    popularArticles(categoryId: $categoryId) {
      totalCount
      articles {
        id
        postID
        title
        url
        hashTags
        tags
        coverImage {
          croppedUrl
        }
        categories {
          name
        }
        publisher {
          photoUrl
          name
          mid
        }
        plainTextContent
      }
    }
  }
`

type GetPopularArticlesParams = {
  categoryId: string
  client: ApolloClient<unknown>
}

async function getPopularArticles(params: GetPopularArticlesParams) {
  const { categoryId, client } = params
  try {
    const response = await client.query<PopularArticles, PopularArticlesVariables>({
      query: POPULAR_ARTICLES,
      variables: {
        categoryId,
      },
    })
    const articles = response?.data?.popularArticles?.articles ?? []
    return articles
  } catch (error) {
    return { ...error }
  }
}

export default getPopularArticles
